import create from "zustand";

export const __default_project_info_state = {
    id: 0,
    service_id: 0,
    service_name: "",
    line_id: 0,
    line_name: "",
    package_id: 0,
    package_name: "",
    is_final: false, //true면 진견적, false면 가견적
    note: "",
    total_discount_rate: 0, //할인율
    package_final_price: 0,
    basic: [],
    addon: [],
    bath: [],
    hardware: [],
    option: [],
    promotion: [],
};

export const __default_fk_project_info_state = {
    id: 0,
    line_id: 0,
    line_name: "",
    package_id: 0,
    package_name: "",
    hardware: [],
    option: [],
};

const __default_store_state = {
    project_info: __default_project_info_state,
};

const __default_fk_store_state = {
    project_info: __default_fk_project_info_state,
};

export const __default_search_state = {
    filter: {
        search_criteria: "",
    },
    paging: { current_page: 1, size: 20, total_page: 1 },
    list: [],
    list_type: "project",
};

export const useSearchStore = create((set) => ({
    filter: {
        search_criteria: "",
    },
    paging: { current_page: 1, size: 20, total_page: 1 },
    list: [],
    list_type: "project",
    setFilter: (filter) =>
        set((state) => {
            return {
                ...state,
                filter,
            };
        }),
    setSearchList: (
        paging = { current_page: 1, size: 20, total_page: 1 },
        list = [],
        list_type = "project"
    ) =>
        set((state) => {
            return { ...state, paging, list, list_type };
        }),
    resetSearchStore: () => set((state) => __default_search_state),
}));

export const useProjectStore = create((set) => ({
    project_info: __default_project_info_state,
    setProjectInfo: (_project) =>
        set((state) => {
            return {
                ...state,
                project_info: { ..._project },
            };
        }),
    resetStore: () =>
        set((state) => {
            return __default_store_state;
        }),
}));

export const useFiveKitchenProjectStore = create((set) => ({
    project_info: __default_fk_project_info_state,
    setProjectInfo: (_project) =>
        set((state) => {
            return {
                ...state,
                project_info: { ..._project },
            };
        }),
    resetStore: () =>
        set((state) => {
            return __default_fk_store_state;
        }),
}));
